// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
::ng-deep .responsive-modal .mat-mdc-dialog-container {
  padding: 0;
  border-radius: 8px;
}
@media (max-width: 768px) {
  ::ng-deep .responsive-modal .mat-mdc-dialog-container {
    margin: 10px;
    width: calc(100vw - 20px);
    height: calc(100vh - 20px);
    max-width: none;
    max-height: none;
  }
}
@media (max-width: 480px) {
  ::ng-deep .responsive-modal .mat-mdc-dialog-container {
    margin: 5px;
    width: calc(100vw - 10px);
    height: calc(100vh - 10px);
  }
}
::ng-deep .responsive-modal .mat-mdc-dialog-content {
  padding: 0;
  margin: 0;
  max-height: none;
}

.main-container {
  padding: 20px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 450px;
}
@media (max-width: 768px) {
  .main-container {
    padding: 15px;
    min-height: 400px;
  }
}
@media (max-width: 480px) {
  .main-container {
    padding: 10px;
    min-height: 350px;
  }
}

h2 {
  margin-top: 0;
  margin-bottom: 20px;
  font-size: 24px;
}
@media (max-width: 768px) {
  h2 {
    font-size: 20px;
    margin-bottom: 15px;
  }
}
@media (max-width: 480px) {
  h2 {
    font-size: 18px;
    margin-bottom: 10px;
  }
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  padding-bottom: 10px;
}

.mat-mdc-row:nth-child(even) {
  background-color: #e3e3e3;
}

.mat-mdc-row:nth-child(odd) {
  background-color: white;
}

.search-input-container {
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}
.search-input-container input {
  flex: 1;
  min-width: 200px;
  font-size: 14px;
  height: 38px;
}
@media (max-width: 768px) {
  .search-input-container input {
    min-width: 150px;
    height: 36px;
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .search-input-container input {
    min-width: 120px;
    height: 34px;
    font-size: 12px;
  }
}
.search-input-container .search-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0066b2 0% 0% no-repeat padding-box;
  min-width: 40px;
  height: 38px;
  color: white;
  font-family: "GothamBold", Arial, sans-serif;
  font-size: 14px;
  cursor: pointer;
  border-radius: 0 4px 4px 0;
}
.search-input-container .search-btn:hover {
  background-color: #0b2d71;
}
@media (max-width: 768px) {
  .search-input-container .search-btn {
    height: 36px;
    font-size: 13px;
    min-width: 36px;
  }
}
@media (max-width: 480px) {
  .search-input-container .search-btn {
    height: 34px;
    font-size: 12px;
    min-width: 34px;
  }
}

.progress-bar-container {
  min-height: 3px;
  margin: 10px 0;
}
.progress-bar-container .searching-progress-bar {
  height: 5px;
}

.table-container {
  flex: 1;
  overflow: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 15px;
  min-height: 200px;
  max-height: calc(100vh - 300px);
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 768px) {
  .table-container {
    margin-bottom: 10px;
    min-height: 150px;
    max-height: calc(100vh - 250px);
  }
}
@media (max-width: 480px) {
  .table-container {
    margin-bottom: 8px;
    min-height: 120px;
    max-height: calc(100vh - 200px);
    background: linear-gradient(90deg, white 30%, transparent), linear-gradient(90deg, transparent, white 70%) 100% 0, radial-gradient(at 0 50%, rgba(0, 0, 0, 0.2), transparent 70%), radial-gradient(at 100% 50%, rgba(0, 0, 0, 0.2), transparent 70%) 100% 0;
    background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
    background-repeat: no-repeat;
    background-attachment: local, local, scroll, scroll;
  }
}

.mat-mdc-table {
  width: 100%;
}
@media (max-width: 768px) {
  .mat-mdc-table {
    font-size: 13px;
  }
}
@media (max-width: 480px) {
  .mat-mdc-table {
    font-size: 12px;
  }
}

.select-col {
  width: 60px;
  min-width: 60px;
  text-align: center;
}
@media (max-width: 480px) {
  .select-col {
    width: 50px;
    min-width: 50px;
  }
}

.code-col {
  width: 30%;
  min-width: 120px;
}
@media (max-width: 768px) {
  .code-col {
    width: 35%;
    min-width: 100px;
  }
}
@media (max-width: 480px) {
  .code-col {
    width: 40%;
    min-width: 80px;
  }
}

.description-col {
  width: auto;
  min-width: 150px;
}
@media (max-width: 768px) {
  .description-col {
    min-width: 120px;
  }
}
@media (max-width: 480px) {
  .description-col {
    min-width: 100px;
  }
}

.name-col {
  max-width: 60%;
}
.name-col .service-code {
  font-size: 12px;
  color: #666;
  font-style: italic;
  margin-left: 8px;
}
@media (max-width: 480px) {
  .name-col .service-code {
    font-size: 10px;
    margin-left: 4px;
  }
}

.selected-services-info {
  margin: 20px 0;
  padding: 15px;
  background-color: #e3e3e3;
  border-radius: 4px;
}
@media (max-width: 768px) {
  .selected-services-info {
    margin: 15px 0;
    padding: 12px;
  }
}
@media (max-width: 480px) {
  .selected-services-info {
    margin: 10px 0;
    padding: 10px;
  }
}
.selected-services-info .selected-list {
  margin-top: 8px;
  font-size: 13px;
  color: #333;
  word-wrap: break-word;
}
@media (max-width: 768px) {
  .selected-services-info .selected-list {
    font-size: 12px;
    margin-top: 6px;
  }
}
@media (max-width: 480px) {
  .selected-services-info .selected-list {
    font-size: 11px;
    margin-top: 4px;
  }
}

.navigation-buttons {
  margin-top: auto;
  padding: 20px 0 0 0;
  border-top: 1px solid #e0e0e0;
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: flex-end;
  flex-wrap: wrap;
  flex-shrink: 0;
  background: white;
  position: sticky;
  bottom: 0;
  z-index: 10;
}
@media (max-width: 768px) {
  .navigation-buttons {
    padding-top: 15px;
    gap: 10px;
    justify-content: center;
  }
}
@media (max-width: 480px) {
  .navigation-buttons {
    padding: 15px 0 0 0;
    gap: 10px;
    justify-content: center;
    flex-direction: column;
    align-items: stretch;
  }
}
@media (max-width: 480px) {
  .navigation-buttons div {
    width: 100%;
  }
}
.navigation-buttons button {
  margin: 0;
  padding: 12px 24px;
  min-height: 44px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}
@media (max-width: 768px) {
  .navigation-buttons button {
    padding: 10px 20px;
    min-height: 40px;
    font-size: 15px;
  }
}
@media (max-width: 480px) {
  .navigation-buttons button {
    padding: 12px 16px;
    font-size: 16px;
    min-height: 48px;
    width: 100%;
  }
}
.navigation-buttons button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}
.navigation-buttons button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.mat-mdc-cell input[type=checkbox] {
  margin-right: 12px;
  vertical-align: middle;
}
@media (max-width: 480px) {
  .mat-mdc-cell input[type=checkbox] {
    margin-right: 8px;
    transform: scale(0.9);
  }
}

.table-container {
  overflow-x: auto;
  margin: 10px 0;
}
@media (max-width: 768px) {
  .table-container {
    margin: 8px 0;
  }
}

.suggest-value-row {
  padding: 6px 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.suggest-value-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  cursor: pointer;
  color: #003366;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 6px 8px;
  border-radius: 4px;
}
.suggest-value-btn:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.04);
}
.suggest-value-btn:disabled {
  opacity: 0.6;
  cursor: default;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
